// src/components/ModalContactar.jsx
import React from "react";

const ModalContactar = ({
    show,
    postulante,
    formData,
    handleInputChange,
    handleSubmit,
    estados,
    onClose,
    errors
}) => {
    if (!show || !postulante) return null;

    const estadosPermitidos = [1, 2, 3, 4];
    const estadosFiltrados = estados.filter((estado) =>
        estadosPermitidos.includes(estado.id)
    );

    return (
        <div className="modal-overlay">
            <div className="modal-content-compact">
                <div className="modal-header">
                    <h3>Contactar</h3>
                    <button className="modal-close-btn" onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className="postulante-info-compact">
                    {postulante.descripcion_postulacion && (
                        <div className="info-item">
                            <span className="info-label">Tipo de Postulación:</span>
                            <span className="info-value">{postulante.descripcion_postulacion}</span>
                        </div>
                    )}

                    {postulante.descripcion_documento && (
                        <div className="info-item">
                            <span className="info-label">Tipo de Documento:</span>
                            <span className="info-value">{postulante.descripcion_documento}</span>
                        </div>
                    )}

                    {postulante.numero_documento && (
                        <div className="info-item">
                            <span className="info-label">Número de Documento:</span>
                            <span className="info-value">{postulante.numero_documento}</span>
                        </div>
                    )}

                    {postulante.nombre_referido && (
                        <div className="info-item">
                            <span className="info-label">Nombre:</span>
                            <span className="info-value">{postulante.nombre_referido}</span>
                        </div>
                    )}

                    {postulante.email && (
                        <div className="info-item">
                            <span className="info-label">Correo Electrónico:</span>
                            <span className="info-value">{postulante.email}</span>
                        </div>
                    )}

                    {postulante.telefono && (
                        <div className="info-item">
                            <span className="info-label">Teléfono:</span>
                            <span className="info-value">{postulante.telefono}</span>
                        </div>
                    )}

                    {postulante.edad !== null && postulante.edad !== '' && (
                        <div className="info-item">
                            <span className="info-label">Edad:</span>
                            <span className="info-value">{postulante.edad} años</span>
                        </div>
                    )}
                    {postulante.fecha_created !== null && postulante.fecha_created !== '' && (
                        <div className="info-item">
                            <span className="info-label">Fecha Solicitud:</span>
                            <span className="info-value">{new Date(postulante.fecha_created).toLocaleString('es-VE', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                hour12: true // 👈 esto activa el formato AM/PM
                            })} </span>
                        </div>
                    )}
                </div>

                <form onSubmit={handleSubmit} className="modal-form-compact">
                    <div className="form-group-compact">
                        <label htmlFor="comentario_contacto">Comentario de Contacto *</label>
                        <textarea
                            name="comentario_contacto"
                            value={formData.comentario_contacto}
                            onChange={handleInputChange}
                            rows="3"
                            placeholder="Ingrese los comentarios del contacto..."
                        />
                        {errors.comentario_contacto && (
                            <span className="error">{errors.comentario_contacto}</span>
                        )}
                    </div>

                    <div className="form-group-compact">
                        <label htmlFor="estado_postulante">Estado *</label>
                        <select
                            id="estado_postulante"
                            name="estado_postulante"
                            value={formData.estado_postulante}
                            onChange={handleInputChange}
                            className="filtro-select"
                        >
                            {estadosFiltrados.map((estado) => (
                                <option key={estado.id} value={estado.id}>
                                    {estado.descripcion}
                                </option>
                            ))}
                        </select>
                        {errors.estado_postulante && (
                            <span className="error">{errors.estado_postulante}</span>
                        )}
                    </div>

                    {formData.estado_postulante == "2" && (
                        <div className="form-group-compact">
                            <label htmlFor="fecha_cita">Fecha y Hora de Cita *</label>
                            <input
                                type="datetime-local"
                                name="fecha_cita"
                                value={formData.fecha_cita}
                                onChange={handleInputChange}
                            />
                            {errors.fecha_cita && (
                                <span className="error">{errors.fecha_cita}</span>
                            )}
                        </div>
                    )}

                    <div className="modal-buttons-compact">
                        <button type="submit" className="btn btn-primary-compact">
                            Guardar
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary-compact"
                            onClick={onClose}
                        >
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalContactar;
